<!--创建广告，计划时的地域组件-->
<template>
  <div class="ny-area">
    <!-- <div class="ny-area__choice">
      <span v-if="isOrder">不选择为全国！</span>已选择：
      <span v-for="item in checkList" class="ny-area__choice-item">&gt;{{item}}</span>
    </div>-->
    <el-checkbox
      :indeterminate="isIndeterminate"
      :disabled="disabled || disableAll"
      v-model="checkAll"
      @change="handleCheckAllChange"
    >{{ entire.length ? entire[0].name : '' }}</el-checkbox>
    <el-checkbox-group v-model="checkedProvinces" @change="handleCheckedProvincesChange">
      <el-checkbox
        v-for="(province, index) in provinces"
        :label="province.value"
        :disabled="disabled || disableProvince && cachedCheckedProvinces.indexOf(province.value) === -1"
        :key="province.value"
      >{{province.name}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import { _typeof } from '@/global/util/util'

export default {
  name: 'NyArea',
  props: {
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    disabled: Boolean, // 禁止选择全国及省份
    entire: {
      type: Array,
      default: () => []
    },
    provinces: { // 后台返的所有地域列表数据
      type: Array,
      required: true,
      default: () => []
    },
    redisplay: Boolean
  },
  data () {
    return {
      checkAll: false, // 全国是否被选择
      cachedCheckedProvinces: [],
      checkedProvinces: this.value,
      isIndeterminate: false,
      disableAll: false, // 是否禁用全国复选框
      disableProvince: false // 是否禁用全国以外的其他所有省份
    };
  },
  methods: {
    handleCheckAllChange (value) {
      this.checkedProvinces = value ? this.provinces.map(v => v.value) : []
      this.isIndeterminate = false
      this.disableProvince = value
      this.$emit('input', value ? [this.entire[0].value] : [])
      this.$emit('change', value ? [this.entire[0].value] : [])
    },
    handleCheckedProvincesChange (value) {
      let checkedCount = value.length
      const { provinces, cachedCheckedProvinces, redisplay } = this
      this.checkAll = checkedCount === provinces.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < provinces.length
      this.disableAll = redisplay ? (
        cachedCheckedProvinces.length > 0 && cachedCheckedProvinces.length < provinces.length && checkedCount >= 0 ||
        cachedCheckedProvinces.length === provinces.length && checkedCount !== 0 ||
        checkedCount > 0
      ) : checkedCount > 0

      this.$emit('input', value)
      this.$emit('change', value)
    }
  },
  watch: {
    value (newVal) {
      if (newVal.length === 1 && newVal[0] === this.entire[0].value) {
        this.checkedProvinces = this.provinces.map(v => v.value)
      } else {
        this.checkedProvinces = newVal
      }
    },
    defaultValue: {
      handler (newVal) {
        if (newVal.length === 1 && newVal[0] === this.entire[0].value) { // 全国
          this.checkAll = true
          this.checkedProvinces = this.provinces.map(v => v.value)
          this.isIndeterminate = false
          this.disableProvince = true

          this.disableAll = false
          this.cachedCheckedProvinces = []
        } else {
          const provinces = this.provinces
          const checkedProvinces = newVal
          const checkedCount = checkedProvinces.length

          this.checkAll = checkedCount > 0 && checkedCount === provinces.length
          this.checkedProvinces = checkedProvinces
          this.isIndeterminate = checkedCount > 0 && checkedCount < provinces.length
          this.disableProvince = checkedCount > 0 && checkedCount < provinces.length

          this.disableAll = this.redisplay ? (
            newVal.length > 0 && newVal.length < provinces.length && checkedCount >= 0 ||
            newVal.length === provinces.length && checkedCount !== 0 ||
            checkedCount > 0
          ) : checkedCount > 0
          this.cachedCheckedProvinces = newVal
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" type="text/scss">
@include b(ny-area) {
  width: 836px;
  padding: 20px 20px 10px 10px;
  min-height: 20px;
  background: #f9f9f9;

  .el-checkbox {
    width: 80px;
    margin-bottom: 10px;
    margin-left: 15px;
  }

  @include e(choice) {
    border-bottom: 1px solid #ccc;
    margin-bottom: 10px;
    padding-bottom: 10px;
    color: #2f6599;
  }

  @include e(choice-item) {
    display: inline-block;
    height: 20px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    color: #2f6599;
  }
}
</style>
